<script>
import Form from '../Form.vue';
import ModalManager from '../../services/modalManager';
import axios from 'axios';
import HandlesErrorResponses from '../../mixins/HandlesErrorResponses';
import HandlesJobs from '../../mixins/Overview/HandlesJobs';
import HandlesActions from '../../mixins/Overview/HandlesActions';
import UrlQueryHelper from '../../services/UrlQueryHelper';

export default {
    mixins: [Form, HandlesErrorResponses, HandlesJobs, HandlesActions],

    methods: {
        async afterSubmit(event) {
            if (event) {
                event.preventDefault();
            }

            const data = new FormData(this.$refs.form);
            if (event && event.submitter?.name && event.submitter?.value) {
                data.append(event.submitter.name, event.submitter.value);
            }

            const params = new URLSearchParams(data).toString();
            const method = this.$refs.form.getAttribute('method').toUpperCase();

            const options = {
                method,
            };

            let url = this.$refs.form.getAttribute('action');

            if (method === 'GET') {
                url = `${url}?${params}`;
            } else {
                options.data = data;
            }

            let job;

            try {
                job = (await axios(url, options)).data;
            } catch (err) {
                await this.handleErrorResponse(err);
                this.formSubmitted = false;

                return;
            }

            if ((new UrlQueryHelper()).isModal()) {
                ModalManager.closeModal({ job });
            } else {
                await this.awaitAndProcessJob(job);

                this.formSubmitted = false;
            }
        },
    },
};
</script>
